import IconTitleItem from "./iconTitleItem";

export default class LinkedTitleItem extends IconTitleItem {
    src: string;

    constructor(title: string, description: string, icon: string, src: string) {
        super(title, description, icon);
        this.src = src;
    }
}
